var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3000",
    "data-name": "Group 3000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132,
    height: 119.551,
    viewBox: "0 0 132 119.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #434343;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1652",
    "data-name": "Rectangle 1652",
    className: "cls-1",
    width: 132,
    height: 119.55
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    "data-name": "Path 4260",
    className: "cls-1",
    d: "M2.344,2.344H129.656V99.063H2.344ZM0,101.407H132V0H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2999",
    "data-name": "Group 2999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    className: "cls-1",
    d: "M130.828,41.456H1.172a1.172,1.172,0,0,1,0-2.344H130.828a1.172,1.172,0,0,1,0,2.344",
    transform: "translate(0 52.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    className: "cls-1",
    d: "M46.483,50.534H23.18l.584-8.066H46.483ZM24.652,49.165H45.114V43.837H25.037Z",
    transform: "translate(31.157 57.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    className: "cls-1",
    d: "M72.4,58.192H16.158V57.02A11.383,11.383,0,0,1,27.527,45.649H61.034A11.383,11.383,0,0,1,72.4,57.02ZM18.577,55.848H69.984a9.042,9.042,0,0,0-8.95-7.855H27.527a9.04,9.04,0,0,0-8.95,7.855",
    transform: "translate(21.718 61.358)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.6d2b6c1562312a47e7f84b63b7b109a8.svg";
export { ForwardRef as ReactComponent };